import { render, staticRenderFns } from "./_create_section_form.vue?vue&type=template&id=ecb97690"
import script from "./_create_section_form.vue?vue&type=script&lang=js"
export * from "./_create_section_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports